export const LogTypes = {
	Logs: 'LOGS',
	AuditTrail: 'AUDIT_TRAIL'
};
